<template>
  <v-hover v-slot:default="{ hover }">
    <v-list-item
      :class="hoverClass(hover)"
      :dark="hover"
      link
    >
      <slot />
    </v-list-item>
  </v-hover>
</template>

<script>
export default {
  Name: 'DarkListItem',

  methods: {
    hoverClass (hover) {
      return {
        'black--text': !hover,
        'white--text secondary elevation-12': hover
      }
    }
  }
}
</script>
